import { render, staticRenderFns } from "./TherapistDashModalLockMonth.vue?vue&type=template&id=34cee8c4&scoped=true"
import script from "./TherapistDashModalLockMonth.vue?vue&type=script&lang=js"
export * from "./TherapistDashModalLockMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cee8c4",
  null
  
)

export default component.exports